
/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';

export namespace SS {

  export class ss_status extends IceEntity {
    table_name: string = "";

    constructor(tbln: string) {
      super();

      this.table_name = tbln;
    }

    gettablename(): string {
      return this.table_name;
    }
  }

  export class ss_sendersoftware extends IceEntity {
    SenderSoftwareDeveloper: string = "";
    SenderSoftwareProduct: string = "";
    SenderSoftwareVersionRelease: string = "";

    constructor() {
      super();
    }

    gettablename(): string {
      return "SenderSoftware";
    }
  }

  export class ss_header extends IceEntity {
    To: string = "";
    From: string = "";
    MessageID: string = "";
    RelatesToMessageID: string = "";
    SentTime: string = "";
    SenderSoftware: ss_sendersoftware[] = [];

    constructor() {
      super();
    }

    gettablename(): string {
      return "Header";
    }

    hassubtree(ColumnName: string): boolean {
      if (ColumnName.length == 0) return false;
      else if (ColumnName == "SenderSoftware") return true;

      return false;
    }

    getsubtreetablename(ColumnName: string): string {
      if (ColumnName.length == 0) return null;
      else if (ColumnName == "SenderSoftware") return "SenderSoftware";

      return null;
    }

    isflattree(ColumnName: string): boolean {
      if (ColumnName.length == 0) return false;
      else if (ColumnName == "SenderSoftware") return true;

      return false;
    }
  }

  export class ss_addproviderlocation extends IceEntity {
  //  SS_DirectoryInformation DirectoryInformation;
  //  SS_ProviderLocation ProviderLocation;
  }

  export class ss_addproviderlocationresponse extends ss_addproviderlocation {
  }

  export class ss_updateproviderlocation extends ss_addproviderlocation {
  }

  export class ss_updateproviderlocationresponse extends ss_addproviderlocation {
  }

  export class ss_getproviderlocation extends ss_addproviderlocation {
  }

  export class ss_getproviderlocationresponse extends ss_addproviderlocation {
  }

  export class ss_body extends IceEntity {

    Error: ss_status[] = [];
    Status: ss_status[] = [];

    constructor() {
      super();
    }

    gettablename(): string {
      return "Body";
    }

    hassubtree(ColumnName: string): boolean {
      if (ColumnName.length == 0) return false;
      else if (ColumnName == "Error") return true;
      else if (ColumnName == "Status") return true;
      else if (ColumnName == "DirectoryDownload") return true;
      else if (ColumnName == "DirectoryDownloadResponse") return true;
      else if (ColumnName == "AddProviderLocation") return true;
      else if (ColumnName == "AddProviderLocationResponse") return true;
      else if (ColumnName == "UpdateProviderLocation") return true;
      else if (ColumnName == "UpdateProviderLocationResponse") return true;
      else if (ColumnName == "GetProviderLocation") return true;
      else if (ColumnName == "GetProviderLocationResponse") return true;

      return false;
    }

    getsubtreetablename(ColumnName: string): string {
      if (ColumnName.length == 0) return null;
      else if (ColumnName == "Error") return "Error";
      else if (ColumnName == "Status") return "Status";
      else if (ColumnName == "DirectoryDownload") return "DirectoryDownload";
      else if (ColumnName == "DirectoryDownloadResponse") return "DirectoryDownloadResponse";
      else if (ColumnName == "AddProviderLocation") return "AddProviderLocation";
      else if (ColumnName == "AddProviderLocationResponse") return "AddProviderLocationResponse";
      else if (ColumnName == "UpdateProviderLocation") return "UpdateProviderLocation";
      else if (ColumnName == "UpdateProviderLocationResponse") return "UpdateProviderLocationResponse";
      else if (ColumnName == "GetProviderLocation") return "GetProviderLocation";
      else if (ColumnName == "GetProviderLocationResponse") return "GetProviderLocationResponse";

      return null;
    }

    isflattree(ColumnName: string): boolean {
      if (ColumnName.length == 0) return false;
      else if (ColumnName == "Error") return true;
      else if (ColumnName == "Status") return true;
      else if (ColumnName == "DirectoryDownload") return true;
      else if (ColumnName == "DirectoryDownloadResponse") return true;
      else if (ColumnName == "AddProviderLocation") return true;
      else if (ColumnName == "AddProviderLocationResponse") return true;
      else if (ColumnName == "UpdateProviderLocation") return true;
      else if (ColumnName == "UpdateProviderLocationResponse") return true;
      else if (ColumnName == "GetProviderLocation") return true;
      else if (ColumnName == "GetProviderLocationResponse") return true;

      return false;
    }
  }

  export class ss_message extends IceEntity {
    Header: ss_header[] = [];
    Body: ss_body[] = [];
    table_name: string = "";

    constructor(tbln: string) {
      super();

      this.table_name = tbln;
    }

    gettablename(): string {
      return this.table_name;
    }
    
    hassubtree(ColumnName: string): boolean {
      if (ColumnName.length == 0) return false;
      else if (ColumnName == "Body") return true;
      else if (ColumnName == "Header") return true;

      return false;
    }

    getsubtreetablename(ColumnName: string): string {
      if (ColumnName.length == 0) return null;
      else if (ColumnName == "Body") return "Body";
      else if (ColumnName == "Header") return "Header";

      return null;
    }

    isflattree(ColumnName: string): boolean {
      if (ColumnName.length == 0) return false;
      else if (ColumnName == "Body") return true;
      else if (ColumnName == "Header") return true;

      return false;
    }
  }
}
